import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const PatientInfoForm = ({ 
  fullName, 
  setFullName, 
  whatsappNumber, 
  handleWhatsAppChange, 
  validationErrors,
  setValidationErrors 
}) => {
  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="User" size={20} color="var(--color-primary)" />
        Suas informações
      </h3>
      <div className="space-y-4">
        {/* Full Name */}
        <div>
          <label htmlFor="fullName" className="block text-sm font-medium text-foreground mb-2">
            Nome completo *
          </label>
          <Input
            id="fullName"
            type="text"
            value={fullName}
            onChange={(e) => {
              setFullName(e?.target?.value);
              if (validationErrors?.fullName) {
                setValidationErrors(prev => ({ ...prev, fullName: '' }));
              }
            }}
            placeholder="Digite seu nome completo"
            className={validationErrors?.fullName ? 'border-destructive' : ''}
          />
          {validationErrors?.fullName && (
            <p className="text-sm text-destructive mt-1 flex items-center gap-1">
              <Icon name="AlertCircle" size={14} color="var(--color-destructive)" />
              {validationErrors?.fullName}
            </p>
          )}
        </div>

        {/* WhatsApp Number */}
        <div>
          <label htmlFor="whatsappNumber" className="block text-sm font-medium text-foreground mb-2">
            WhatsApp (com código do país) *
          </label>
          <Input
            id="whatsappNumber"
            type="tel"
            value={whatsappNumber}
            onChange={handleWhatsAppChange}
            placeholder="+55 (00) 00000-0000"
            maxLength={20}
            className={validationErrors?.whatsappNumber ? 'border-destructive' : ''}
          />
          {validationErrors?.whatsappNumber && (
            <p className="text-sm text-destructive mt-1 flex items-center gap-1">
              <Icon name="AlertCircle" size={14} color="var(--color-destructive)" />
              {validationErrors?.whatsappNumber}
            </p>
          )}
          <p className="text-xs text-muted-foreground mt-1">
            Digite com código do país (ex: +55 21 99999-9999)
          </p>
        </div>
      </div>
    </div>
  );
};

export default PatientInfoForm;